<template>
  <modal ref="modal">
    <modal-body :message="message" />
    <modal-footer>
      <register-button @click="doRegister" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import CancelButton from '@/views/molecules/buttons/CancelButton';
import RegisterButton from "@/views/molecules/buttons/RegisterButton";

export default {
  name: "RegisterConfirmModal",
  emits: ['register'],
  props: {
    message: {
      type: String,
      default: "登録してよろしいですか？",
    },
  },
  components: {
    RegisterButton,
    Modal,
    ModalBody,
    ModalFooter,
    CancelButton,
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    doRegister() {
      this.$refs.modal.hide();
      this.$emit('register');
    },
  },
}
</script>
